export default __webpack_public_path__ + "static/media/DO.045d888f.svg";